import { createSlice } from "@reduxjs/toolkit";
import { firebaseErrorMessage } from "../../../utilities/general";
import { createPerson, getCompany, getPersonInfo, getCuenta, limpiarPerson } from "./actions";


const initialState = () => ({
    person: {
        items: false,
        loading: false,
        error: false,
        company: false,
        persona: false,
        cuenta: false,
        message: false
    }
});

export const personSlice = createSlice({
    name: "personslice",
    initialState: initialState().person,
    reducers: {},

    
    extraReducers: (builder) => {
        //Recupera informacion de la persona
        builder.addCase(getPersonInfo.pending, (source) => {
            source.loading = true;
        });
        builder.addCase(getPersonInfo.fulfilled, (source, action) => {
            source.items = action.payload;
            source.loading = false;
        });
        builder.addCase(getPersonInfo.rejected, (source) => {
            source.loading = false;
            source.error = source;
            
        });
        //Crear una nueva persona
        builder.addCase(createPerson.pending, (source) => {
            source.loading = true;
        });
        builder.addCase(createPerson.fulfilled, (source, action) => {
            source.persona = action.payload;
            source.error = false;
            source.loading = false;
        });
        builder.addCase(createPerson.rejected, (source, action) => {
            console.log("action.error", action.error)
            const errorMessage = action.error.code ? firebaseErrorMessage(action.error.code): action.error.message
            source.loading = false;
            source.persona = false;
            source.error = {
                ...action.error,
                message: errorMessage
            }
        });

        //Obtener el codigo de la compañia 
        builder.addCase(getCompany.pending, (source) => {
            source.loading = true;
        });
        builder.addCase(getCompany.fulfilled, (source, action) => {
            source.company = action.payload;
            source.loading = false;
        });
        builder.addCase(getCompany.rejected, (source) => {
            source.loading = false;
            source.error = source;
            
        });

        //Recuperar valor maximo de id de las compañias
        builder.addCase(getCuenta.pending, (source) => {
            source.loading = true;
        });
        builder.addCase(getCuenta.fulfilled, (source, action) => {
            source.cuenta = action.payload;
            source.loading = false;
        });
        builder.addCase(getCuenta.rejected, (source) => {
            source.loading = false;
            source.error = source;
            
        });

        builder.addCase(limpiarPerson, (source, action) => {
            //console.log("reducer lipmpiar persona", action)
            source.persona = false;
        });
    },
});

export const selectItems = (state) => state.person.items;
export const selectLoading = (state) => state.person.loading;
export const selectError = (state) => state.person.error;
export const selectPersona = (state) => state.person.persona;
export const selectCompany =  (state) => state.person.company;
export const selectCuenta =  (state) => state.person.cuenta;

export default personSlice.reducer;